/** @format */

import { setGlobal } from 'reactn';

export const PRESERVE_CART_ON_RETURN_KEY = 'preserveCartOnReturn';
export const CART_UPDATED_EVENT = 'pharol:cart-updated';

const isEmptyParam = (value) =>
	value == null || value === '' || value === 'null' || value === 'undefined';

/** Clear bag as soon as payment is confirmed (do not wait for "Volver al inicio"). */
export const clearCartAfterSuccessfulPayment = () => {
	localStorage.setItem('cart', JSON.stringify([]));
	localStorage.removeItem('onDemandData');
	localStorage.removeItem('validVoucher');
	setGlobal({
		cart: [],
		carQuantity: 0,
	});
	window.dispatchEvent(new Event(CART_UPDATED_EVENT));
};

/**
 * MercadoPago "volver a tienda" without paying hits failure URL with null ids/status.
 * Real rejections usually include a payment_id and a concrete status.
 */
export const isMercadoPagoAbandonedReturn = (search) => {
	const params = new URLSearchParams(
		typeof search === 'string' ? search : search?.search || window.location.search || '',
	);
	const status = params.get('status');
	const paymentId = params.get('payment_id');
	const collectionId = params.get('collection_id');

	const hasMpFingerprint =
		params.has('preference_id') || params.has('external_reference') || params.has('site_id');

	if (!hasMpFingerprint) {
		return false;
	}

	return isEmptyParam(status) && isEmptyParam(paymentId) && isEmptyParam(collectionId);
};

export const isMercadoPagoApprovedReturn = (search) => {
	const params = new URLSearchParams(
		typeof search === 'string' ? search : search?.search || window.location.search || '',
	);
	const status = params.get('status');
	const collectionStatus = params.get('collection_status');
	return status === 'approved' || collectionStatus === 'approved';
};

export const markPreserveCartOnReturn = () => {
	sessionStorage.setItem(PRESERVE_CART_ON_RETURN_KEY, '1');
};

export const consumePreserveCartOnReturn = () => {
	const shouldPreserve = sessionStorage.getItem(PRESERVE_CART_ON_RETURN_KEY) === '1';
	if (shouldPreserve) {
		sessionStorage.removeItem(PRESERVE_CART_ON_RETURN_KEY);
	}
	return shouldPreserve;
};

export const redirectToCartPreservingCart = () => {
	markPreserveCartOnReturn();
	window.location.replace('/cart');
};
